import { c as _c } from "react/compiler-runtime";
import type { IntroEffectMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import ChatGradePrefixImage from '../../../_components/ChatGradePrefixImage';
interface Props {
  fontSizeClass?: string;
  item: IntroEffectMessage;
}
export default function IntroEffectChat(props) {
  const $ = _c(9);
  const {
    fontSizeClass,
    item
  } = props;
  const {
    message
  } = item.data;
  let t0;
  if ($[0] !== message.lev || $[1] !== message.rk) {
    t0 = <ChatGradePrefixImage type="chatter" level={message.lev} ranking={message.rk} className="mr-2 h-[14px] w-[14px]" />;
    $[0] = message.lev;
    $[1] = message.rk;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = `${message.nk}님 입장`;
  let t2;
  if ($[3] !== fontSizeClass || $[4] !== t1) {
    t2 = <div className={fontSizeClass}>{t1}</div>;
    $[3] = fontSizeClass;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <div className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 flex w-full transform animate-fade-in-stay-fade-out items-center justify-center opacity-0"><div className="rounded-md bg-intro-effect-border p-0.5"><div className="flex items-center rounded-md border bg-white px-1">{t0}{t2}</div></div></div>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}